<template>
	<div>
		<!--
		<b-container>
			<b-row>
				<b-col> 
-->
		<GroupCallButton :recipients="groupCallRecipients" />
		<b-table
			striped
			hover
			:items="items"
			:fields="fields"
			:filter="filter"
			@filtered="onFiltered"
			:filter-function="filterFunction"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:per-page="perPage"
			:current-page="currentPage"
			:tbody-tr-class="rowClass"
		>
			<template slot="thead-top">
				<b-tr>
					<b-th>
						<b-form-input
							v-model="filter.block"
							:placeholder="this.$t('vehicle_report.block') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th colspan="2">
						<b-form-input
							v-model="filter.vehicle"
							:placeholder="this.$t('vehicle_report.vehicle_label') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th colspan="2">
						<b-form-input
							v-model="filter.organisation"
							:placeholder="this.$t('vehicle.organisation') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th>
						<b-form-input
							v-model="filter.type"
							:placeholder="this.$t('vehicle_report.vehicle_type') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th v-if="this.$UiConfig('/data/departure/showCourse', false)">
						<b-form-input
							v-model="filter.tripShortName"
							:placeholder="this.$t('vehicle_report.course') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th>
						<b-form-input
							v-model="filter.line"
							:placeholder="this.$t('vehicle_report.line') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th>
						<b-form-input
							v-model="filter.destination"
							:placeholder="this.$t('vehicle_report.destination') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th colspan="2">
						<b-form-input
							v-model="filter.stop"
							:placeholder="this.$t('vehicle_report.latest_stop') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
					<b-th colspan="2">
						<b-form-input
							v-model="filter.nextStop"
							:placeholder="this.$t('vehicle_report.next_stop') + '...'"
							size="sm"
							type="search"
							debounce="300"
						></b-form-input>
					</b-th>
				</b-tr>
			</template>
			<template v-slot:cell(gpsTimestamp)="data">
				<VehicleBrief :label="data.item.vehicleLabel" :showLabel="false">
				</VehicleBrief>
			</template>
			<template v-slot:cell(vehicleLabel)="data">
				<VehicleBrief :label="data.item.vehicleLabel" :showGps="false">
				</VehicleBrief>
			</template>
			<template v-slot:cell(actions)="data">
				<VehicleBrief
					:label="data.item.vehicleLabel"
					:showLabel="false"
					:showGps="false"
					:showIndividualCall="true"
					:addGroupCall="true"
					:showVehicleOnMap="showLinkToVehicleOnMap()"
				>
				</VehicleBrief>
			</template>
			<template v-slot:cell(deviation)="data">
				<div :style="getDeviationStyle(data.item.deviation)">
					<p class="deviation">{{ formatDeviation(data.item.deviation) }}</p>
				</div>
			</template>
		</b-table>

		<TablePagination
			:total-rows="totalRows"
			:per-page="perPage"
			@pageChange="onPageChange"
			:currentPage="currentPage"
			@perPageChange="onPerPageChange"
			:extendedPagination="true"
			:perPageArray="[20, 40, 60]"
		>
		</TablePagination>
	</div>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination'
import vehicleReport from '@/store/realtime/vehicleReport'
import deviationColors from '@/store/system/deviationColors'
import moment from 'moment'
import VehicleBrief from '@/components/Realtime/VehicleBrief'
import realtime from '@/store/realtime/realtime'
import GroupCallButton from '@/components/Dispatching/VoIP/GroupCallButton'
import realtimeLogic from '@/services/realtimeLogic'

export default {
	components: { TablePagination, VehicleBrief, GroupCallButton },
	data: function () {
		return {
			perPage: 20,
			currentPage: 1,
			filteredRows: 0,
			filter: {
				block: null,
				vehicle: null,
				type: null,
                tripShortName: null,
				line: null,
				organisation: null,
				destination: null,
				stop: null,
				nextStop: null,
			},
			dataUpdater: null,
			sortBy: 'gpsTimestamp',
			sortDesc: true,
			dataUpdateTime: null,
			filteredItems: [],
		}
	},
	computed: {
		fields() {
			let fields = [
				{
					key: 'block',
					label: this.$t('vehicle_report.block'),
					sortable: true,
				},
				{
					key: 'gpsTimestamp',
					label: this.$t('vehicle_report.gps'),
					sortable: true,
				},
				{
					key: 'vehicleLabel',
					label: this.$t('vehicle_report.vehicle_label'),
					sortable: true,
				},

				{
					key: 'actions',
					label: this.$t('vehicle_report.actions'),
					sortable: true,
				},
				{
					key: 'organisation.name',
					label: this.$t('vehicle.organisation'),
					sortable: true,
				},
				{
					key: 'vehicleType',
					label: this.$t('vehicle_report.vehicle_type'),
					sortable: true,
				}
            ];
            if (this.$UiConfig('/data/departure/showCourse', false)) {
                fields.push({
					key: 'tripShortName',
					label: this.$t('vehicle_report.course'),
					sortable: true,
                });
           }
            fields = [ ...fields,
				{ key: 'line', label: this.$t('vehicle_report.line'), sortable: true },
				{
					key: 'latestStopOnRoute',
					label: this.$t('vehicle_report.latest_stop_on_route'),
					sortable: true,
				},
				{
					key: 'nextStop',
					label: this.$t('vehicle_report.next_stop'),
					sortable: true,
				},
				{
					key: 'destination',
					label: this.$t('vehicle_report.destination'),
					sortable: true,
				},
				{
					key: 'latestStopOnRouteTime',
					label: this.$t('vehicle_report.time'),
					sortable: true,
					formatter: function (value) {
						let time = new moment(value, 'YYYY-MM-DD[T]HH:mm:ssZZ').format(
							'DD.MM.YYYY HH:mm'
						)
						if (time.startsWith('Invalid')) {
							return ''
						}
						return time
					},
				},
				{
					key: 'deviation',
					label: this.$t('vehicle_report.deviation'),
					sortable: true,
					formatter: this.formatDeviation,
				},
			];
            return fields;
		},
		items() {
			let list = this.$store.state.vehicleReport.vehicleReportList
			if (!Array.isArray(list)) return []

			list.forEach((item) => {
				if (
					item.block == null ||
					item.deviation == null ||
					['danger', 'dark'].includes(this.gpsVariant(item.gpsTimestamp))
				) {
                    item.tripShortName = null;
					item.line = null
					item.destination = null
					item.latestStopOnRoute = null
					item.latestStopOnRouteTime = null
					item.nextStop = null
					item.deviation = null
				}
			})
			return list
		},
		totalRows() {
			if (this.filteredRows) return this.filteredRows
			return this.items ? this.items.length : 0
		},
		groupCallRecipients() {
			return this.filteredItems
				.map((item) => {
					return this.$store.getters['realtime/getVehicleByLabel'](
						item.vehicleLabel
					)?.features['SIP_CLIENT_ID']
				})
				.filter((sipID) => {
					return sipID != null
				})
		},
	},
	beforeCreate() {
		if (!this.$store.state.deviationColors) {
			this.$store.registerModule('deviationColors', deviationColors)
		}
		if (!this.$store.state.realtime) {
			this.$store.registerModule('realtime', realtime)
		}
		this.$store.dispatch('deviationColors/getDeviationColors')
	},
	created() {
		if (!this.$store.state.vehicleReport) {
			this.$store.registerModule('vehicleReport', vehicleReport)
		}
		this.updateData()
	},
	beforeDestroy() {
		clearTimeout(this.dataUpdater)
	},
	methods: {
		onFiltered(filteredItems) {
			this.filteredRows = filteredItems.length

			//if there aren't rows on current page, set page to 1st.
			if (Math.ceil(this.filteredRows / this.perPage) < this.currentPage) {
				this.currentPage = 1
			}
			this.filteredItems = filteredItems
		},
		filterFunction(itemRow) {
			if (filterOutItem(this.filter.block, itemRow.block))
                return false;
			if (filterOutItem(this.filter.vehicle, itemRow.vehicleLabel))
                return false;
			if (filterOutItem(this.filter.organisation, itemRow.organisation.name))
				return false;
			if (filterOutItem(this.filter.type, itemRow.vehicleType))
                return false;
            if (filterOutItem(this.filter.tripShortName, itemRow.tripShortName))
                return false;
			if (filterOutItem(this.filter.line, itemRow.line))
                return false;
			if (filterOutItem(this.filter.destination, itemRow.destination))
				return false;
			if (filterOutItem(this.filter.stop, itemRow.latestStopOnRoute))
				return false;
			return !filterOutItem(this.filter.nextStop, itemRow.nextStop)
		},
		gpsVariant(gpsTimestamp) {
			if (!gpsTimestamp) {
				return 'dark'
			}
			let gpsTime = new moment(gpsTimestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ')
			let compTime = new moment()
			if (gpsTime.isBefore(compTime.subtract(3, 'minutes'))) {
				return 'danger'
			}
			if (gpsTime.isBefore(compTime.add(2, 'minutes'))) {
				return 'warning'
			}
			return 'success'
		},
		formatDeviation(value) {
			if (value == null) {
				return '';
			}
			const prettyDeviation = realtimeLogic.getDeviationInRightFormat2(value, false);
			if (!prettyDeviation) {
				return '';
			}
			return prettyDeviation;
		},
		getDeviationStyle(deviation) {
			let sec = deviation / 1000;
			for (let deviationColor of this.$store.state.deviationColors
				.deviationColors) {
				if (
					sec &&
					(deviationColor.minval == null ||
						deviationColor.minval <= sec) &&
					(deviationColor.maxval == null || deviationColor.maxval >= sec)
				) {
					return 'background-color: ' + deviationColor.primarycolor + ';'
				}
			}
			return ''
		},
		onPageChange(page) {
			this.currentPage = page
		},
		onPerPageChange(perPage) {
			this.perPage = perPage
			this.onFiltered(this.filteredItems)
		},
		rowClass(item) {
			if (
				['warning', 'danger', 'dark'].includes(
					this.gpsVariant(item.gpsTimestamp)
				)
			) {
				return 'old-data-row'
			}
			return ''
		},
		updateData() {
			this.$store.dispatch('vehicleReport/getVehicleReportList')
			clearTimeout(this.dataUpdater)
			this.dataUpdater = setTimeout(() => {
				this.dataUpdateTime = Date.now()
			}, 30000)
		},
		showLinkToVehicleOnMap() {
			return this.$UiConfig('/ui/actions/showLinkToVehicleOnMap', true)
		}
	},
	watch: {
		dataUpdateTime: function () {
			this.updateData()
		},
	},
}

function filterOutItem(filter, item) {
	if (filter == null || filter.length == 0) return false
	if (item == null) return true

	// If last char is space item has to be exaclty like filter
	if (filter.slice(-1) == ' ') {
		return item.toLowerCase() !== filter.toLowerCase().trim()
	}

	return !item.toLowerCase().includes(filter.toLowerCase())
}
</script>

<style>
.old-data-row td {
	color: lightgray;
}

.old-data-row:hover td {
	color: rgb(192, 192, 192);
}
</style>

<style scoped lang="scss">
table {
	height: 1px;
}
tr {
	height: 100%;
}
td {
	height: 100%;
}
td > div {
	height: 100%;
	width: 100%;
	display: inline-table;
	text-align: center;
}
.deviation {
	display: table-cell;
	vertical-align: middle;
	color: #000000;

	color: #fff;
	font-weight: bold;
}
</style>
